import { buildFetchOptionsWithAuth, fetchJson, useQuery } from '@fv/client-core'

import { apiUri } from '@/constants'

import type { SharedShipment } from './types'

async function fetchSharedShipment(
  loadId: string,
  shareToken?: string,
): Promise<SharedShipment> {
  const endpoint = new URL(`${apiUri}/share/${loadId}`)
  if (shareToken) endpoint.searchParams.set('token', shareToken)

  const options = buildFetchOptionsWithAuth()
  const response = await fetchJson(endpoint.toString(), options)

  if (response.ok) return response.json
  throw response.errorMessage
}

export function useSharedShipment(loadId: string, shareToken?: string) {
  return useQuery(
    ['shared-shipment', loadId, shareToken],
    () => fetchSharedShipment(loadId, shareToken),
    {
      retry: (
        failCount: number,
        error: { message?: string; status: number },
      ) => {
        if (error.status === 404) return false
        return failCount < 3
      },
    },
  )
}
